/*
  Curated first product for collection pages.

  Supported URL parameters:
  - first: required. Product handle, product path, or encoded full product URL.
  - variant: optional. Shopify variant ID to preserve on pinned product links.
  - limit: optional. Maximum number of visible product cards after pinning.
  - source: optional. Collection handle to search when the product card is not
    already rendered in the current collection grid.

  How to test:
  /collections/best-sellers?first=my-product-handle
  /collections/best-sellers?first=my-product-handle&variant=1234567890
  /collections/best-sellers?first=https%3A%2F%2Fexample.com%2Fproducts%2Fmy-product-handle%3Fvariant%3D1234567890&limit=16

  Loaded from sections/main-collection-product-grid.liquid and the custom
  infinite grid block in blocks/ai_gen_block_f4cf189.liquid.
*/
(function () {
  'use strict';

  if (window.__curatedFirstFromSourceLoaded) return;
  window.__curatedFirstFromSourceLoaded = true;

  var PRODUCT_PATH_RE = /\/products\/([^/?#]+)/i;
  var CURATED_PARAMS = ['first', 'variant', 'limit', 'source'];
  var state = {
    applying: false,
    observer: null,
    timer: null,
    fetchedCards: Object.create(null),
    fetchedProducts: Object.create(null),
  };

  function isCollectionPage() {
    return window.location.pathname.indexOf('/collections/') === 0;
  }

  function safeDecode(value) {
    var decoded = value || '';

    for (var index = 0; index < 2; index += 1) {
      try {
        var next = decodeURIComponent(decoded);
        if (next === decoded) break;
        decoded = next;
      } catch (error) {
        break;
      }
    }

    return decoded;
  }

  function normalizeHandle(handle) {
    return safeDecode(handle || '')
      .trim()
      .replace(/^\/+|\/+$/g, '')
      .split(/[?#]/)[0]
      .toLowerCase();
  }

  function extractProductInfo(firstValue, explicitVariant) {
    var rawFirst = safeDecode(firstValue || '').trim();
    var variant = explicitVariant || '';
    var handle = '';
    var match = rawFirst.match(PRODUCT_PATH_RE);

    if (match && match[1]) {
      handle = match[1];
    } else {
      try {
        var url = new URL(rawFirst, window.location.origin);
        match = url.pathname.match(PRODUCT_PATH_RE);

        if (match && match[1]) {
          handle = match[1];
          if (!variant) variant = url.searchParams.get('variant') || '';
        } else {
          handle = rawFirst;
        }
      } catch (error) {
        handle = rawFirst;
      }
    }

    if (!variant) {
      try {
        variant = new URL(rawFirst, window.location.origin).searchParams.get('variant') || '';
      } catch (error) {
        variant = '';
      }
    }

    return {
      handle: normalizeHandle(handle),
      variant: (variant || '').replace(/\D/g, ''),
    };
  }

  function getConfig() {
    var params = new URLSearchParams(window.location.search);
    var first = params.get('first');

    if (!first) return null;

    var productInfo = extractProductInfo(first, params.get('variant'));
    var limit = parseInt(params.get('limit') || '', 10);
    var source = normalizeHandle(params.get('source') || '');

    if (!productInfo.handle) return null;

    return {
      first: productInfo.handle,
      variant: productInfo.variant,
      limit: Number.isFinite(limit) && limit > 0 ? limit : null,
      source: source,
    };
  }

  function getGrid() {
    var grid = document.querySelector('[data-curated-products-grid]');
    if (grid) return grid;

    grid = document.getElementById('product-grid');
    return grid && grid.matches('ul.product-grid') ? grid : null;
  }

  function productHandleFromUrl(urlValue) {
    if (!urlValue) return '';

    try {
      var url = new URL(urlValue, window.location.origin);
      var match = url.pathname.match(PRODUCT_PATH_RE);
      return match && match[1] ? normalizeHandle(match[1]) : '';
    } catch (error) {
      var fallbackMatch = String(urlValue).match(PRODUCT_PATH_RE);
      return fallbackMatch && fallbackMatch[1] ? normalizeHandle(fallbackMatch[1]) : '';
    }
  }

  function getCardHandle(card) {
    if (!card) return '';
    if (card.dataset && card.dataset.productHandle) return normalizeHandle(card.dataset.productHandle);

    var links = [];

    if (card.matches && card.matches('a[href*="/products/"], [data-product-url*="/products/"], [data-url*="/products/"]')) {
      links.push(card);
    }

    links = links.concat(
      Array.prototype.slice.call(card.querySelectorAll('a[href*="/products/"], [data-product-url*="/products/"], [data-url*="/products/"]'))
    );

    for (var index = 0; index < links.length; index += 1) {
      var handle = productHandleFromUrl(
        links[index].getAttribute('href') ||
          links[index].getAttribute('data-product-url') ||
          links[index].getAttribute('data-url')
      );
      if (handle) return handle;
    }

    return '';
  }

  function findCardInGrid(grid, handle) {
    var cards = Array.prototype.slice.call(grid.children);

    return cards.find(function (card) {
      return getCardHandle(card) === handle;
    });
  }

  function productUrlWithVariant(urlValue, handle, variant) {
    if (!variant) return urlValue;

    var original = urlValue || '/products/' + handle;
    var isAbsolute = /^https?:\/\//i.test(original);
    var url;

    try {
      url = new URL(original, window.location.origin);
    } catch (error) {
      url = new URL('/products/' + handle, window.location.origin);
    }

    if (!productHandleFromUrl(url.href)) {
      url = new URL('/products/' + handle, window.location.origin);
    }

    url.searchParams.set('variant', variant);
    return isAbsolute ? url.href : url.pathname + url.search + url.hash;
  }

  function updateVariantLinks(card, handle, variant) {
    if (!variant) return;

    if (card.matches && card.matches('a[href*="/products/"]') && productHandleFromUrl(card.getAttribute('href')) === handle) {
      card.setAttribute('href', productUrlWithVariant(card.getAttribute('href'), handle, variant));
    }

    card.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      if (productHandleFromUrl(link.getAttribute('href')) === handle) {
        link.setAttribute('href', productUrlWithVariant(link.getAttribute('href'), handle, variant));
      }
    });

    ['data-product-url', 'data-url'].forEach(function (attributeName) {
      card.querySelectorAll('[' + attributeName + '*="/products/"]').forEach(function (element) {
        if (productHandleFromUrl(element.getAttribute(attributeName)) === handle) {
          element.setAttribute(attributeName, productUrlWithVariant(element.getAttribute(attributeName), handle, variant));
        }
      });
    });
  }

  function imageUrlAtWidth(src, width) {
    try {
      var url = new URL(src, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.href;
    } catch (error) {
      return src;
    }
  }

  function fetchProductJson(handle) {
    if (!handle) return Promise.resolve(null);
    if (state.fetchedProducts[handle]) return state.fetchedProducts[handle];

    state.fetchedProducts[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .catch(function () {
        return null;
      });

    return state.fetchedProducts[handle];
  }

  function getVariantFeaturedImage(product, variant) {
    if (!product || !variant || !Array.isArray(product.variants)) return null;

    var matchingVariant = product.variants.find(function (item) {
      return String(item.id) === String(variant);
    });
    if (!matchingVariant) return null;

    if (matchingVariant.featured_image && matchingVariant.featured_image.src) {
      return matchingVariant.featured_image;
    }

    if (
      matchingVariant.featured_media &&
      matchingVariant.featured_media.preview_image &&
      matchingVariant.featured_media.preview_image.src
    ) {
      return matchingVariant.featured_media.preview_image;
    }

    return null;
  }

  function updateVariantImage(card, handle, variant, product) {
    if (!variant) return Promise.resolve();

    function applyVariantImage(productData) {
      var featuredImage = getVariantFeaturedImage(productData, variant);
      var src = featuredImage && featuredImage.src;
      var primaryImage = card.querySelector('.card__media img, img[class*="product-image"]');

      if (!src || !primaryImage) return;

      primaryImage.setAttribute('src', imageUrlAtWidth(src, 533));
      primaryImage.setAttribute(
        'srcset',
        [165, 360, 533, 720, 940, 1066]
          .map(function (width) {
            return imageUrlAtWidth(src, width) + ' ' + width + 'w';
          })
          .join(', ')
      );

      if (featuredImage.alt) primaryImage.setAttribute('alt', featuredImage.alt);
      if (featuredImage.width) primaryImage.setAttribute('width', String(featuredImage.width));
      if (featuredImage.height) primaryImage.setAttribute('height', String(featuredImage.height));
    }

    if (product) {
      applyVariantImage(product);
      return Promise.resolve();
    }

    return fetchProductJson(handle).then(function (productData) {
      applyVariantImage(productData);
    });
  }

  function removeDuplicateCards(grid, pinnedCard, handle) {
    Array.prototype.slice.call(grid.children).forEach(function (card) {
      if (card !== pinnedCard && getCardHandle(card) === handle) card.remove();
    });
  }

  function updateAnimationOrder(grid) {
    Array.prototype.slice.call(grid.children).forEach(function (card, index) {
      if (card.style && card.style.getPropertyValue('--animation-order')) {
        card.style.setProperty('--animation-order', String(index + 1));
      }
    });
  }

  function applyLimit(grid, limit) {
    if (!limit) return;

    Array.prototype.slice.call(grid.children).forEach(function (card, index) {
      if (index >= limit) card.remove();
    });
  }

  function collectionPathForSource(source) {
    if (source) return '/collections/' + encodeURIComponent(source);

    var match = window.location.pathname.match(/^(\/collections\/[^/?#]+)/);
    return match ? match[1] : '';
  }

  function searchParamsForFetch(pageNumber, sectionId) {
    var params = new URLSearchParams(window.location.search);
    CURATED_PARAMS.forEach(function (param) {
      params.delete(param);
    });
    params.set('section_id', sectionId);
    params.set('page', String(pageNumber));
    return params;
  }

  function fetchCollectionDocument(source, pageNumber, sectionId) {
    var collectionPath = collectionPathForSource(source);
    if (!collectionPath) return Promise.resolve(null);

    var url = collectionPath + '?' + searchParamsForFetch(pageNumber, sectionId).toString();
    return fetch(url)
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (html) {
        return html ? new DOMParser().parseFromString(html, 'text/html') : null;
      })
      .catch(function () {
        return null;
      });
  }

  function fetchedCardCacheKey(source, handle, sectionId) {
    return [source || window.location.pathname, handle, sectionId].join('|');
  }

  function fetchRenderedCard(config, sectionId) {
    var cacheKey = fetchedCardCacheKey(config.source, config.first, sectionId);
    if (state.fetchedCards[cacheKey]) return state.fetchedCards[cacheKey];

    state.fetchedCards[cacheKey] = new Promise(function (resolve) {
      var maxPagesToSearch = 10;

      function searchPage(pageNumber) {
        if (pageNumber > maxPagesToSearch) {
          resolve(null);
          return;
        }

        fetchCollectionDocument(config.source, pageNumber, sectionId).then(function (doc) {
          if (!doc) {
            resolve(null);
            return;
          }

          var grid = doc.getElementById('product-grid');
          if (!grid) {
            resolve(null);
            return;
          }

          var match = findCardInGrid(grid, config.first);
          if (match) {
            resolve(match);
            return;
          }

          if (!doc.querySelector('.pagination a[href*="page=' + (pageNumber + 1) + '"]')) {
            resolve(null);
            return;
          }

          searchPage(pageNumber + 1);
        });
      }

      searchPage(1);
    });

    return state.fetchedCards[cacheKey];
  }

  function findInfiniteGridElement(grid) {
    return grid && grid.closest ? grid.closest('[data-curated-infinite-grid]') : null;
  }

  function fetchProductFromJsonCollection(config, grid) {
    var infiniteGrid = findInfiniteGridElement(grid);
    if (!infiniteGrid || typeof infiniteGrid.createProductCard !== 'function') return Promise.resolve(null);

    var collectionHandle = config.source || normalizeHandle(infiniteGrid.dataset.collection || '');
    if (!collectionHandle) return Promise.resolve(null);

    var productsPerLoad = parseInt(infiniteGrid.dataset.productsPerLoad || '16', 10);
    var limit = Number.isFinite(productsPerLoad) && productsPerLoad > 0 ? productsPerLoad : 16;
    var maxPagesToSearch = 10;

    function searchPage(pageNumber) {
      if (pageNumber > maxPagesToSearch) return Promise.resolve(null);

      var url = '/collections/' + encodeURIComponent(collectionHandle) + '/products.json?page=' + pageNumber + '&limit=' + limit;

      return fetch(url)
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (data) {
          var products = data && Array.isArray(data.products) ? data.products : [];
          var product = products.find(function (item) {
            return normalizeHandle(item.handle) === config.first;
          });

          if (product) {
            var card = infiniteGrid.createProductCard(product);
            card.dataset.curatedProductCard = 'true';
            card.dataset.productHandle = normalizeHandle(product.handle);
            return card;
          }

          if (products.length < limit) return null;
          return searchPage(pageNumber + 1);
        })
        .catch(function () {
          return null;
        });
    }

    return searchPage(1);
  }

  function pinCard(grid, card, config, product) {
    if (!card) return;

    state.applying = true;
    card.dataset.productHandle = config.first;
    card.dataset.curatedPinned = 'true';

    updateVariantLinks(card, config.first, config.variant);
    updateVariantImage(card, config.first, config.variant, product)
      .catch(function () {
        /* Variant images are optional. Keep the pinning flow moving if the request fails. */
      })
      .finally(function () {
        if (grid.firstElementChild !== card) grid.insertBefore(card, grid.firstElementChild);
        removeDuplicateCards(grid, card, config.first);
        applyLimit(grid, config.limit);
        updateAnimationOrder(grid);
        state.applying = false;
      });
  }

  function applyCuratedFirst() {
    if (state.applying || !isCollectionPage()) return;

    var config = getConfig();
    var grid = getGrid();
    if (!config || !grid) return;

    var existingCard = findCardInGrid(grid, config.first);
    if (existingCard) {
      pinCard(grid, existingCard, config);
      return;
    }

    fetchProductFromJsonCollection(config, grid).then(function (jsonCard) {
      if (jsonCard) {
        fetchProductJson(config.first).then(function (product) {
          pinCard(grid, jsonCard, config, product);
        });
        return;
      }

      return fetchRenderedCard(config, grid.dataset.id).then(function (fetchedCard) {
        if (!fetchedCard) return;
        pinCard(grid, fetchedCard.cloneNode(true), config);
      });
    });
  }

  function scheduleApply() {
    window.clearTimeout(state.timer);
    state.timer = window.setTimeout(applyCuratedFirst, 60);
  }

  function installObserver() {
    var container = document.getElementById('ProductGridContainer') || document.body;
    if (state.observer) state.observer.disconnect();

    state.observer = new MutationObserver(function () {
      if (!state.applying) scheduleApply();
    });
    state.observer.observe(container, { childList: true, subtree: true });
  }

  function init() {
    if (!isCollectionPage()) return;
    installObserver();
    applyCuratedFirst();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
